<template>
  <div>
    <v-container fluid>

      <div class="main">

        <v-row v-if="isLoading2">
          <v-col v-for="item in 4" :key="item" cols="12" lg="3">
            <v-card class="rounded-lg shadow">
              <v-card-text>
                <v-skeleton-loader type="list-item-avatar-three-line"></v-skeleton-loader>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-else>
          <v-col cols="12" lg="3">
            <v-card class="rounded-lg shadow">
              <v-card-text class="py-5">
                <v-row align="center" justify="center">
                  <v-col cols="3">
                    <v-avatar color="info" size="45">
                      <v-icon color="white">mdi-credit-card-multiple-outline</v-icon>
                    </v-avatar>
                  </v-col>
                  <v-col cols="9">
                    <div class="font-weight-black title pb-1 grey--text text--darken-3">
                      {{ statistics.total_created }}
                    </div>
                    Cartes créées
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" lg="3">
            <v-card class="rounded-lg shadow">
              <v-card-text class="py-5">
                <v-row align="center" justify="center">
                  <v-col cols="3">
                    <v-avatar color="success" size="45">
                      <v-icon color="white">mdi-check-circle-outline</v-icon>
                    </v-avatar>
                  </v-col>
                  <v-col cols="9">
                    <div class="font-weight-black title pb-1 grey--text text--darken-3">
                      {{ statistics.total_used }}
                    </div>
                    Cartes Utilisées
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" lg="3">
            <v-card class="rounded-lg shadow">
              <v-card-text class="py-5">
                <v-row align="center" justify="center">
                  <v-col cols="3">
                    <v-avatar color="red" size="45">
                      <v-icon color="white">mdi-cancel</v-icon>
                    </v-avatar>
                  </v-col>
                  <v-col cols="9">
                    <div class="font-weight-black title pb-1 grey--text text--darken-3">
                      {{ statistics.total_canceled }}
                    </div>
                    Cartes Annulées
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" lg="3">
            <v-card class="rounded-lg shadow">
              <v-card-text class="py-5">
                <v-row align="center" justify="center">
                  <v-col cols="3">
                    <v-avatar color="purple" size="45">
                      <v-icon color="white">mdi-cash-multiple</v-icon>
                    </v-avatar>
                  </v-col>
                  <v-col cols="9">
                    <div class="font-weight-black title pb-1 grey--text text--darken-3">
                      {{ CurrencyFormatting(statistics.total_value) }} pts
                    </div>
                    Valeur totale rachetée
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-tabs background-color="transparent">
              <v-tab @click="[dataStatus='all',getData()]">
                <v-icon left>mdi-view-list</v-icon>
                Tous
              </v-tab>
              <v-tab @click="[dataStatus='shipped',getData()]">
                <v-icon left>mdi-truck-check</v-icon>
                Livrées
              </v-tab>
              <v-tab @click="[dataStatus='used',getData()]">
                <v-icon left>mdi-check-circle-outline</v-icon>
                Utilisées
              </v-tab>
              <v-tab @click="[dataStatus='canceled',getData()]">
                <v-icon left>mdi-cancel</v-icon>
                Annulées
              </v-tab>
            </v-tabs>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card class="rounded-lg shadow">

              <v-card-title>

                <div>
                  <v-text-field
                      v-model="keyword"
                      append-icon="mdi-magnify"
                      @keydown.enter="getData"
                      hint="Appuyez sur ↵ Entrée pour rechercher"
                      clearable
                      @click:clear="[keyword=null,getData()]"
                      dense
                      filled
                      persistent-hint
                      placeholder="Recherche..."
                      rounded
                  ></v-text-field>
                </div>

                <v-spacer/>

                <v-btn color="grey"
                       text
                       @click="[getData(),getStatistics()]">
                  <v-icon left>mdi-refresh</v-icon>
                  Mettre à jour
                </v-btn>

                <v-btn color="grey"
                       text
                >
                  <v-icon left>mdi-filter-outline</v-icon>
                  Filtrer
                </v-btn>

              </v-card-title>

              <v-divider/>

              <v-card-text v-if="isLoading">
                <v-skeleton-loader type="table"/>
              </v-card-text>

              <div v-else>
                <v-card-text>
                  <v-simple-table class="table-border rounded-lg" v-if="batchs.length">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th class="text-no-wrap">Tracking</th>
                        <th class="text-no-wrap">Nom complet</th>
                        <th class="text-no-wrap">Téléphone</th>
                        <th class="text-no-wrap">Wilaya</th>
                        <th>Montant</th>
                        <th>Code</th>
                        <th>Statut</th>
                        <th>Créer le</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item ,index) in batchs" :key="index">

                        <td class="font-weight-bold">
                          {{ item.tracking }}
                        </td>

                        <td>
                          {{ item.user.name }}
                        </td>

                        <td>
                          {{ item.user.phone }}
                        </td>


                        <td class="font-weight-medium">
                          {{ item.user.wilaya.name }}
                        </td>

                        <td class="font-weight-bold gifty-text">
                          {{ CurrencyFormatting(item.montant) }}
                        </td>

                        <td class="font-weight-bold">
                          {{ item.voucher?.code }}
                        </td>

                        <td>
                          <v-btn depressed
                                 small
                                 dark
                                 :color="statusColor(item.status)"
                                 class="text-uppercase">
                            {{ item.status }}
                          </v-btn>
                        </td>

                        <td class="font-weight-medium">
                          {{ item.created_at }}
                        </td>

                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <div v-else>
                    <NoResults @reload="getData"/>
                  </div>

                </v-card-text>
                <v-divider/>

                <v-card-actions>

                  <div :style="{width: '120px'}">
                    <v-select v-model="perPage"
                              :items="[10,20,30,50,100]"
                              dense
                              hide-details
                              label="Ligne par page"
                              outlined></v-select>
                  </div>

                  <v-spacer/>


                  <span class="text--darken-2 grey--text">
                      {{ pageStart }}-{{ pageEnd }} de {{ total }}
                  </span>
                  <v-pagination v-model="pagination.current"
                                :length="pagination.total"
                                circle
                                total-visible="8"
                                @input="getData"></v-pagination>

                </v-card-actions>

              </div>
            </v-card>
          </v-col>
        </v-row>

      </div>

    </v-container>

  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import NoResults from "@/components/NoResults";

export default {
  components: {NoResults},
  data() {
    return {
      keyword: '',
      dataStatus: 'all',
      btnLoading: false,
      isLoading2: false,
      statistics: {},
      isLoading: false,
      batchs: [],
      total: 0,
      perPage: 10,
      pagination: {
        current: 1,
        total: 0
      },
    };
  },
  methods: {
    statusColor(status) {
      if (status === "created") {
        return "info lighten-1"
      }
      if (status === "shipped") {
        return "purple lighten-1"
      }
      if (status === "used") {
        return "success lighten-1"
      }
      if (status === "canceled") {
        return "orange lighten-1"
      }
      if (status === "failed") {
        return "red lighten-1"
      }
    },
    getData() {
      this.isLoading = true
      HTTP.get('/v1/noest/backoffice?page=' + this.pagination.current, {
        params: {
          perPage: this.perPage,
          status: this.dataStatus,
          keyword: this.keyword
        }
      }).then(res => {

        this.pagination.current = res.data.data.current_page;
        this.pagination.total = res.data.data.last_page;
        this.total = res.data.data.total;

        this.batchs = res.data.data.data

        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    getStatistics() {
      this.isLoading2 = true
      HTTP.get('/v1/noest/backoffice/statistics').then(res => {
        this.statistics = res.data.data
        this.isLoading2 = false
      }).catch(err => {
        this.isLoading2 = false
        console.log(err)
      })
    },
  },
  created() {
    this.getData();
    this.getStatistics();
  },
  computed: {
    pageStart() {
      if (this.total === 0) return 0
      return (this.pagination.current - 1) * this.perPage + 1
    },
    pageEnd() {
      let end = this.pagination.current * this.perPage
      return end > this.total ? this.total : end
    }
  },
  watch: {
    perPage() {
      this.pagination.current = 1
      this.getData();
    },
  }
};
</script>

<style scoped></style>
